import jwtAuthAxios from "./auth/jwtAuth";

const deliveryServices = {};

// deliveryServices.getDeliveryReceipt = async (delivery_id, params) => {
//     const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/details${params || ""}`);
//     return data;
// };

deliveryServices.getDeliveryDetails = async (delivery_id, params) => {
    const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/details${params || ""}`);
    return data;
};

deliveryServices.getDocsImages = async (delivery_id) => {
    const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/docs_images`);
    return data;
};

// Fotos de los bultos del pedido de esta entrega (ver orderServices.getPackagePhotos).
deliveryServices.getPackagePhotos = async (delivery_id) => {
    const {data} = await jwtAuthAxios.get(`/deliveries/${delivery_id}/package_photos`);
    return data;
};

deliveryServices.updateDelivery = async (delivery_id, params) => {
    const {data} = await jwtAuthAxios.put(`/deliveries/${delivery_id}`, params);
    return data;
};

// Cambia la direccion de una parada por otra del mismo cliente (icono de mapa del
// instructivo). No toca la direccion principal del cliente.
// `address` es una direccion del cliente ({ id }) o una nueva solo para este pedido
// ({ geoPath, address }), que el backend no suma a las direcciones del cliente.
deliveryServices.setPlannedAddress = async (delivery_id, address) => {
    const payload = address?.geoPath
        ? { geoPath: address.geoPath, address: address.address }
        : { customer_address_id: address?.id ?? address };
    const { data } = await jwtAuthAxios.post(`/deliveries/${delivery_id}/planned_address`, payload);
    return data;
};

deliveryServices.updateReceipt = async (delivery_id, params) => {
    const { data } = await jwtAuthAxios.put(`/deliveries/${delivery_id}/update_receipt`, params);
    return data;
};

deliveryServices.updateState = async (delivery_id, state) => {
    const { data } = await jwtAuthAxios.post(`/deliveries/${delivery_id}/state`, { state });
    return data;
};

deliveryServices.unassignPreparer = async (deliveryId) => {
    const { data } = await jwtAuthAxios.post(`/deliveries/${deliveryId}/unassign_preparer`);
    return data;
};


deliveryServices.cancelForTrip = async (deliveryId, tripId) => {
    const { data } = await jwtAuthAxios.post(`/deliveries/${deliveryId}/cancel_for_trip`, { trip_id: tripId });
    return data;
};

export default deliveryServices;
